module.exports = __webpack_public_path__ + "static/media/white_queen.0ee31a3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pieces/white_queen.png
// module id = 153
// module chunks = 0